import styled from '@emotion/styled';
import Markdown from 'react-markdown';
import { MixinTypographyDisplaySmall, MixinTypographyLightSmall } from './Typography';

// MARKDOWN
export const StyledMarkdown = styled(Markdown)`
    font-weight: 400;
    font-size: 1.313rem; // 21px
    color: ${(props) => props.theme.color.textBody};
    line-height: 2rem; // 32px
    a {
        font-size: 1.125rem; // 18px
        line-height: 1.625rem; // 26px
        display: block;
        color: ${(props) => props.theme.color.secondary};
        text-decoration: underline;
        :hover {
            color: ${(props) => props.theme.color.secondary};
            text-decoration: none;
        }
    }
`;

export const StyledMarkdownContainer = styled.div`
    ${MixinTypographyLightSmall};
    color: ${(props) => props.theme.color.textBody};
    padding: 2rem 0;
    line-height: 2rem; // 32px
    & a,
    * a {
        font-size: 1.125rem; // 18px
        line-height: 1.625rem; // 26px
        display: block;
        color: ${(props) => props.theme.color.link};
        text-decoration: underline;
        :hover {
            color: ${(props) => props.theme.color.link};
            text-decoration: none;
        }
    }
    & code,
    * code {
        background-color: ${(props) => props.theme.color.background + 90};
        font-family: 'Courier New', Courier, monospace;
    }
    & pre,
    * pre {
        overflow-x: auto;
        background-color: ${(props) => props.theme.color.card};
        border-radius: 0.5rem;
        padding: 1rem 1rem 1rem 1rem !important;
    }
    & h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: ${(props) => props.theme.color.text};
        font-weight: 900;
    }
    & h1 {
        ${MixinTypographyDisplaySmall};
    }
    & h2 {
        font-size: 1.75rem; // 28px
        line-height: 2.25rem; // 36px
    }
    & h3 {
        font-size: 1.5rem; // 24px
        line-height: 2rem; // 32px
    }
    & h4 {
        font-size: 1.25rem; // 20px
        line-height: 1.75rem; // 28px
    }
    & h5 {
        font-size: 1.125rem; // 18px
        line-height: 1.625rem; // 26px
    }
    & h6 {
        font-size: 1rem; // 16px
        line-height: 1.313rem; // 21px
    }
    & ul,
    ol,
    * ul,
    * ol {
        padding-left: 2rem;
    }
`;

export const WorkflowMarkdownContent = styled.div`
    p {
        margin: 0 0 0.5em;
    }
    p:last-child {
        margin-bottom: 0;
    }
    h1,
    h2,
    h3,
    h4 {
        margin: 0.75em 0 0.375em;
        font-weight: 600;
    }
    h1 {
        font-size: 1.1em;
    }
    h2 {
        font-size: 1em;
    }
    h3 {
        font-size: 0.95em;
    }
    ul,
    ol {
        margin: 0.25em 0 0.5em;
        padding-left: 1.25em;
    }
    li {
        margin-bottom: 0.15em;
    }
    code {
        background: ${(p) => p.theme.color.cardHover};
        border-radius: 4px;
        padding: 0.1em 0.35em;
        font-size: 0.875em;
        font-family: 'Fira Code', 'Consolas', monospace;
    }
    pre {
        background: ${(p) => p.theme.color.cardHover};
        border-radius: 6px;
        padding: 0.75em 1em;
        overflow-x: auto;
        margin: 0.5em 0;
        code {
            background: none;
            padding: 0;
        }
    }
    blockquote {
        border-left: 3px solid ${(p) => p.theme.color.accent};
        margin: 0.5em 0;
        padding: 0.25em 0.75em;
        opacity: 0.85;
    }
    table {
        border-collapse: collapse;
        width: 100%;
        font-size: 0.875em;
        margin: 0.5em 0;
    }
    th,
    td {
        border: 1px solid ${(p) => p.theme.color.border};
        padding: 0.375em 0.625em;
    }
    th {
        font-weight: 600;
        background: ${(p) => p.theme.color.cardHover};
    }
    a {
        color: ${(p) => p.theme.color.accent};
        text-decoration: none;
    }
    a:hover {
        text-decoration: underline;
    }
    hr {
        border: none;
        border-top: 1px solid ${(p) => p.theme.color.border};
        margin: 0.75em 0;
    }
    strong {
        font-weight: 600;
    }
    em {
        font-style: italic;
    }
`;
